module.exports = __webpack_public_path__ + "assets/telerik-sitefinity.834358e5.svg";